import parse from 'date-fns/parse';
import isAfter from 'date-fns/isAfter';
import compareAsc from 'date-fns/compareAsc';
import { CHAT_EPISODE_TITLE } from 'app-modules/base/constants';
import { selectors } from 'app-webtech-core';

let lastLinearChannelStatus = null;
let chatEpisodes = [];

function getChatEpisodes(channelList) {
  const res = [];
  channelList.forEach((channel) => {
    if (channel && channel.timelines) {
      const now = Date.now();
      const chatTimelines = channel.timelines.filter(
        (tmln) => tmln.title.includes(CHAT_EPISODE_TITLE) && isAfter(tmln.start, now),
      );

      chatTimelines.forEach((tmln) => {
        // eslint-disable-next-line no-underscore-dangle
        res.push({ channelId: channel._id, chatStartsOn: parse(tmln.start) });
      });
    }
  });
  // Lets sort it, so we can just take the top one, when looking for next Chat episode.
  res.sort((a, b) => compareAsc(b.chatStartsOn, a.chatStartsOn));
  return res;
}

/**
 * Returns the start of coming chat episode
 * returns null iff there are no future Chat episodes in linearChannels
 * returns `{ channel, chatStartsOn: date}` for current/coming Chat episode
 *  Note that chatStartsOn can not be in the past. if we are in the middle of an already started
 *  episode it is just ignored and the next one is returned.
 *  Note: if there are 2 or more Chat Episodes on the timeline, returns the earliest one (that
 *  starts in the future)
 */
export const chatEpisodeStartsOn = (state) => {
  const linearChannels = selectors.linearChannels.properties(state);
  const lcStatus = linearChannels.status;
  // As getting all the ChatEpisodes implies looping trough every timeline in every channel in
  // linearChannels, we will do it only when the linearChannels are updated (received from server)
  if (lcStatus !== lastLinearChannelStatus) {
    lastLinearChannelStatus = lcStatus;
    if (lcStatus === 'DONE') {
      const channelList = selectors.linearChannels.channelList(state);
      chatEpisodes = getChatEpisodes(channelList);
    }
  }
  const now = Date.now();
  while (chatEpisodes.length > 0) {
    const top = chatEpisodes[chatEpisodes.length - 1];
    if (isAfter(top.chatStartsOn, now)) {
      return top;
    }
    chatEpisodes.pop();
  }
  return null;
};
